import { connect } from 'react-redux'

import { fetchPaidEventsSterams } from './paidEventsActions'
import PaidEvents from './PaidEvetns'

const mapStateToProps = state => ({
  streams: state.paidEvents.streams,
  isLoading: state.paidEvents.isLoading,
  personId: state.authorization.personId
})

const mapDispatchToProps = dispatch => ({
  fetchPaidStreams: personId => dispatch(fetchPaidEventsSterams(personId))
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  fetchPaidStreams: () => dispatchProps.fetchPaidStreams(stateProps.personId)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PaidEvents)
